// extracted by mini-css-extract-plugin
module.exports = {"heading":"TechnicalSkills_heading__1vRKD"};